export function is_user_active(user) {
  return user.status === "active";
}

// Function to convert timestamp to human readable format
export const toHumanFormat = (timestamp) => {
  const date = new Date(timestamp * 1000);
  return date.toLocaleString();
};

// Function to get tags for a domain from malicious data
export const getTags = (maliciousData, domain) => {
  if (domain === undefined) {
    return [];
  }
  if (domain in maliciousData) {
    return maliciousData[domain.toString()].tags;
  }
  return [];
};

// Function to convert malicious data list to an object keyed by domain
export const setMaliciousData = (maliciousDataList) => {
  const returnData = {};
  if (maliciousDataList !== null) {
    maliciousDataList.forEach((element) => {
      returnData[element.domain] = element;
    });
  }
  return returnData;
};

// Function to determine bubble color based on domain tags
export const getBubbleColor = (
  domainTags,
  maliciousTags,
  adultSiteTags,
  maliciousColor,
  purpleColor,
  defaultColor,
  id,
) => {
  if (domainTags.length > 0) {
    // Check for malicious tags first
    if (domainTags.some((tag) => maliciousTags.has(tag))) {
      return maliciousColor(id);
    }
    // Then check for adult tags
    if (domainTags.some((tag) => adultSiteTags.has(tag))) {
      return purpleColor(id);
    }
  }
  // Default to orange
  return defaultColor(id);
};
